import styled from '@nobia/zeus-components/lib/styled'
import rem from '@nobia/zeus-components/lib/styled/rem'
import PropTypes from 'prop-types'
import React from 'react'

import { Icon } from '../icons'

const Button = styled.button`
  position: relative;
  height: ${rem(36)};
  width: ${rem(36)};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  background-color: ${(p) => p.theme.close.background};
`

const Close = ({ onClick, className }) => (
  <Button className={className} onClick={onClick}>
    <Icon name="close" width={16} height={16} />
  </Button>
)

Close.defaultProps = {
  onClick: () => {},
  className: '',
}

Close.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
}

export default Close
